import { render, staticRenderFns } from "./DrinkTrendChip.vue?vue&type=template&id=2defe29b&"
import script from "./DrinkTrendChip.vue?vue&type=script&lang=js&"
export * from "./DrinkTrendChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports